module.exports = __webpack_public_path__ + "img/zhuban_bg.c0b9ce23.png";